var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8ffea023233c1bd2ae1a21988a27a5c5d39616eb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-main@flipgive"]={id:"8ffea023233c1bd2ae1a21988a27a5c5d39616eb"};
      